import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { STORAGE_KEYS } from './api.config';
import { AuthServiceNg } from './auth.service';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthServiceNg);
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  if (!token) return router.parseUrl('/signin') as UrlTree;
  return auth.validateToken().pipe(
    map(() => true),
    catchError(() => of(router.parseUrl('/signin') as UrlTree))
  );
};


